import { useTranslation } from 'react-i18next'

import { ColorPicker } from '@reveni-io/reveni-ui'

import { literalTranslationOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/TrackingPagePreview/constants'

const BlockSettingColorField = ({ field, value, onChange }) => {
  const { t } = useTranslation()

  const handleChange = color => onChange(field.key, color)

  return <ColorPicker label={t(field.label, literalTranslationOptions)} defaultColor={value} onChange={handleChange} />
}

export default BlockSettingColorField
